module.exports = __webpack_public_path__ + "img/icon_horse.9e058c4e.svg";